module.exports = __webpack_public_path__ + "img/registrationcom.f36bac08.png";